import { render } from "./ExportBtn.vue?vue&type=template&id=683d9e55&scoped=true"
import script from "./ExportBtn.vue?vue&type=script&lang=js"
export * from "./ExportBtn.vue?vue&type=script&lang=js"

import "./ExportBtn.vue?vue&type=style&index=0&id=683d9e55&scoped=true&lang=css"

import exportComponent from "D:\\xampp\\htdocs\\chandigarh\\kanda\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-683d9e55"]])

export default __exports__